export default "__VITE_ASSET__BmYp2ElR__"